// extracted by mini-css-extract-plugin
export default {"pageWrap":"jb-z","fullWidth":"kb-z","heading":"lb-z","fullBleed":"mb-z","hidden":"nb-z"};